import {
    convertCurrencyFormatPositiveNegative,
    convertPersianDateToUniversalDate,
    convertUniversalDateTimeToPersianDateTime,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoChipTypes,
    RaikoCustomSelect,
    raikoCustomSelectItemGenerator,
    RaikoCustomSimpleChip,
    RaikoCustomTable,
    RaikoDatePicker,
    RaikoLabel,
    RaikoGridOneColumn,
    RaikoNumberInputOutlined,
    RaikoTableSearchContainer,
    RaikoTableTitleContainer,
    showErrorMessage,
    showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {RouteHelper} from "../../route/RouteHelper";
import React, {useEffect, useState} from "react";
import {useNavigate, useSearchParams} from "react-router-dom";
import {css} from "@emotion/css";
import PointsStatistics from "../../raicheComponents/statistics/PointsStatistics";
import {LoanRequestsService} from "../../serverService/loanRequests/LoanRequestsService";
import {useAuthState} from "../../context/AuthContext";
import {useDebounce} from "@uidotdev/usehooks";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {stringIsEmpty} from "../../util/VariableChecker";

export default function LoanRequests() {

    const {fundID} = useAuthState()

    const [searchParam, setSearchParam] = useSearchParams();
    const [page, setPage] = useState(searchParam.get("page") || 1);
    const size = 20

    const navigate = useNavigate()

    const [fullName, setFullName] = useState(searchParam.get("full-name") || "");
    const [accountCode, setAccountCode] = useState(searchParam.get("account-code") || "");
    const [startDate, setStartDate] = useState(searchParam.get("start-date") || "")
    const [endDate, setEndDate] = useState(searchParam.get("end-date") || "")

    const [sortTypes, setSortTypes] = useState("ID_DESC")


    const filterFullName = useDebounce(fullName, 300)
    const filterAccountCode = useDebounce(accountCode, 300)
    const filterStartDate = useDebounce(startDate, 300)
    const filterEndDate = useDebounce(endDate, 300)

    const [tableLoading, setTableLoading] = useState(true)
    const [installments, setInstallments] = useState([])
    const [pageCount, setPageCount] = useState(0);
    const [totalItems, setTotalItems] = useState(0);

    const [summationsOfAwaitingForReview, setSummationsOfAwaitingForReview] = useState("در حال محاسبه")

    const service = new LoanRequestsService()


    useEffect(() => {
        getRequests()
        getPendingRequestsTotalAmount()
    }, [
        fundID,
        page,
        filterFullName,
        filterAccountCode,
        filterStartDate,
        filterEndDate,
        sortTypes
    ]);

    function prepareNewRow(number, id, amount, depositAccountNumber, firstName, lastName, kind, numberOfMonthsOfWaiting, numberOfInstallments, sendAt, enabled) {
        return {
            number,
            id,
            fullName: firstName && lastName ? `${firstName} ${lastName}` : "-",
            sendAt: convertUniversalDateTimeToPersianDateTime(sendAt),
            depositAccountNumber,
            amount: convertCurrencyFormatPositiveNegative(amount),
            numberOfInstallments,
            numberOfMonthsOfWaiting: numberOfMonthsOfWaiting ? numberOfMonthsOfWaiting : "-",
            kind,
            enabled: enabled === "AWAITING_FOR_REVIEW" ?
                <RaikoCustomSimpleChip title={"در حال بررسی"} type={RaikoChipTypes.warning}/> :
                enabled === "ACCEPTED" ?
                    <RaikoCustomSimpleChip title={"پذیرفته شده"} type={RaikoChipTypes.success}/> :
                    enabled === "CANCELLED" ?
                        <RaikoCustomSimpleChip title={"لغو شده"} type={RaikoChipTypes.error}/> :
                        <RaikoCustomSimpleChip title={"رد شده"} type={RaikoChipTypes.error}/>,
        }
    }

    function getRequests() {
        setTableLoading(true)
        service.getLoanRequests(
            fundID,
            page - 1,
            size,
            filterFullName,
            filterAccountCode,
            filterStartDate ? convertPersianDateToUniversalDate(filterStartDate) : "",
            filterEndDate ? convertPersianDateToUniversalDate(filterEndDate) : "",
            sortTypes
        ).then(response => {
            setTotalItems(response.numberOfItems)
            setPageCount(response.totalPage)

            setInstallments([])
            response.data.map((item, index) => {
                setInstallments(prev => [
                    ...prev,
                    prepareNewRow(
                        ((page - 1) * size) + index + 1,
                        item.id,
                        item.amount,
                        item.depositAccountNumber,
                        item.firstName,
                        item.lastName,
                        item.loanKindPersianName,
                        item.numberOfMonthsOfWaiting,
                        item.numberOfInstallments,
                        item.sendAt,
                        item.status
                    )
                ])
            })
        }).catch(reason => {
            showWarningMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setTableLoading(false)
        })
    }

    function getPendingRequestsTotalAmount() {
        service.getPendingAmount(
            fundID
        ).then(response => {
            setSummationsOfAwaitingForReview(response.summationsOfAwaitingForReview)
        }).catch(reason => {
            showWarningMessage(detectServerErrorMessage(reason))
        }).finally(_ => {

        })
    }

    function handleChangePagination(newPage) {
        setPage(newPage + 1)
    }


    function handleDeleteAllFilters() {
        setAccountCode("")
        setStartDate("")
        setEndDate("")
        setSortTypes("ID_DESC")
    }

    function handleShowDetail(id) {
        let title = ""

        installments.map((item) => {
            if (item.id === id) {
                title = item.fullName
            }
        })

        navigate(
            RouteHelper.LoansRequestsDetail.globalUrl.replace(":id", id),
            {state: {title: title}, replace: false}
        )
    }

    return (
        <RaikoBaseContainer>
            <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                <RaikoBreadcrumb breadCrumbItems={[
                    raikoBreadCrumbItemGenerator(RouteHelper.LoansRequests.name, ""),
                ]}/>

                <PointsStatistics
                    title={"مجموع وام های در حال بررسی (ریال)"}
                    amount={summationsOfAwaitingForReview}
                    iconFile={""}
                />


                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        <RaikoTableTitleContainer
                            title={"درخواست وام"}
                            amount={totalItems}
                        />

                        <RaikoTableSearchContainer
                            hasFilter={true}
                            labelText={"نام و نام خانوادگی"}
                            placeHolder={"عبارت مورد نظر را وارد نمایید"}
                            setValue={setFullName}
                            value={fullName}
                            handleDeleteAllFilters={handleDeleteAllFilters}
                            filterStatus={
                                !stringIsEmpty(filterAccountCode) ||
                                !stringIsEmpty(filterStartDate) ||
                                sortTypes !== "ID_DESC" ||
                                !stringIsEmpty(filterEndDate)
                            }
                        >
                            <RaikoGridOneColumn>

                                <RaikoLabel text={"| فیلتر"}/>

                                <RaikoNumberInputOutlined
                                    labelText={"شناسه حساب"}
                                    value={accountCode}
                                    setValue={setAccountCode}/>

                                <RaikoDatePicker
                                    label={"تاریخ شروع"}
                                    date={startDate}
                                    setDate={setStartDate}/>

                                <RaikoDatePicker
                                    label={"تاریخ پایان"}
                                    date={endDate}
                                    setDate={setEndDate}/>

                                <RaikoLabel className={css`margin-top: .5rem;`} text={"| مرتب سازی"}/>
                                <RaikoCustomSelect
                                    labelText={"مرتب سازی"}
                                    value={sortTypes}
                                    setValue={setSortTypes}
                                    items={[
                                        raikoCustomSelectItemGenerator(
                                            "ID_DESC", "تاریخ نزولی"
                                        ), raikoCustomSelectItemGenerator(
                                            "ID_ASC", "تاریخ صعودی"
                                        ), raikoCustomSelectItemGenerator(
                                            "NUMBER_OF_MONTHS_OF_WAITING_DESC", "ماه انتظار نزولی"
                                        ), raikoCustomSelectItemGenerator(
                                            "NUMBER_OF_MONTHS_OF_WAITING_ASC", "ماه انتظار صعودی"
                                        ),
                                    ]}
                                />

                            </RaikoGridOneColumn>

                        </RaikoTableSearchContainer>


                        <RaikoCustomTable
                            header={header}
                            data={installments}
                            isLoading={tableLoading}
                            pageCount={pageCount}
                            newPage={page}
                            handlePaginationChange={handleChangePagination}
                            emptyListTitle={"هیچ درخواستی یافت نشد."}
                            rowClicked={handleShowDetail}
                        />

                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>

            </RaikoGridOneColumn>
        </RaikoBaseContainer>
    )
}


const header = [
    {
        id: 'number',
        label: '#',
        align: 'right',
    },
    {
        id: 'fullName',
        label: 'نام و نام خانوادگی',
        align: 'right',
    },
    {
        id: 'depositAccountNumber',
        label: 'شماره حساب',
        align: 'right',
    },
    {
        id: 'kind',
        label: 'نوع وام',
        align: 'right',
    },
    {
        id: 'numberOfMonthsOfWaiting',
        label: 'ماه انتظار',
        align: 'right',
    },
    {
        id: 'numberOfInstallments',
        label: 'تعداد اقساط',
        align: 'right',
    },
    {
        id: 'amount',
        label: 'مبلغ (ریال)',
        align: 'right',
    },
    {
        id: 'sendAt',
        label: 'تاریخ ارسال',
        align: 'right',
    },
    {
        id: 'enabled',
        label: 'وضعیت',
        align: 'right',
    },
];
